import React from 'react';
import PropTypes from 'prop-types';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import {
    isEmpty,
    extractWorkSheetData,
    getWithExpiry,
    formatDate,
    ExcelDateToDateString
} from "../../../globals/GlobalFunctions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import axios from 'axios';
import {refreshToken} from "../../../globals/GlobalFunctions";
import Autocomplete from "@mui/material/Autocomplete";
import {GlobalConstants} from "../../../globals/GlobalConstants";
import TextField from "@mui/material/TextField";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";

export interface Props {
    excelData: any;
    currentDB: string;
}

function BulkExCodePut({excelData, currentDB}: Props) {
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState(false);
    const [validationText, setValidationText] = React.useState("");
    const [validationError, setValidationError] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [currentExCode, setCurrentExCode] = React.useState({ex_Code: "",
        admin_Override: "0", category: "", ex_Description: "", ex_Result: "", vbasoftware_database: "CoastalAdminTest", vbapi_Token: "", hipaA_Code: "",
        hipaA_Group_Code: "", long_Description: "", no_Print_On_Remit: "0", override_Denied: false, override_Pend: false, patient_Responsibility: false, print_Only: false,
        suppress_EOB_Remit: false, hipaA_Remit_Code: ""});

    let token = localStorage.getItem('jwt');

    const handleValidationClose = () => {
        setValidationError(false);
        setValidationText("");
    }

    const initialExCodeState = {
        ex_Code: "",
        admin_Override: "0",
        category: "",
        ex_Description: "",
        ex_Result: "",
        vbasoftware_database: "CoastalAdminTest",
        vbapi_Token: "",
        hipaA_Code: "",
        hipaA_Group_Code: "",
        long_Description: "",
        no_Print_On_Remit: "0",
        override_Denied: false,
        override_Pend: false,
        patient_Responsibility: false,
        print_Only: false,
        suppress_EOB_Remit: false,
        hipaA_Remit_Code: ""
    }

    const clearExCodes = () => {
        setCurrentExCode({...initialExCodeState});
    }

    const importExCodes = async (exCodeArray : any[]) => {
        refreshToken();
        setIsLoading(true);
        const response =
            await axios
                .put(
                    localStorage.getItem('baseURL') + 'exCode/putList',
                    exCodeArray,
                    {headers: {'Authorization': `Bearer ${token}`, accept: "*/*", "Content-Type": "application/json"}}
                ).then(() => {
                    setLoading(false);
                    setSuccessAlert(true);
                    setIsLoading(false);
                }).catch((error) => {
                    //console.log(response);
                    setLoading(false);
                    setValidationText(error.response.request.responseText);
                    setValidationError(true);
                    setIsLoading(false);
                });
        //console.log(response);
    }

    try {
        //Check for data and that there is a sheet in the data named IDCodeValue
        if (!isEmpty(excelData) && excelData.Sheets.ExCodes !== undefined) {
            //console.log(excelData, "Made it to formatter!");

            //global function to extract the data into a sequential array of cell data values as well as the column and row ranges
            let sheetDataArray = extractWorkSheetData(excelData.Sheets.ExCodes);

            let rawCellArray: any[] = sheetDataArray[0];

            let columnRange: number = sheetDataArray[1];

            let rowRange: number = sheetDataArray[2];

            let exCodeArray: any[] = [];

            //console.log(rawCellArray, "Raw Data");

            //we need to find the column index of the values we require so we can grab the data for each row -- THIS IS WHERE COLUMN NAMES ARE SET
            //we add 1 for each for the loop multiplier to account for it being zero based, but later we subtract 1 to account for the very fist row actually starting at zero
            const exCodeIndexCollection = {
                exCodeIndex: rawCellArray.indexOf('Ex_Code') + 1,
                descriptionIndex: rawCellArray.indexOf('Ex_Description') + 1,
                resultIndex: rawCellArray.indexOf('Ex_Result') + 1,
                categoryIndex: rawCellArray.indexOf('Category') + 1,
                noPrintIndex: rawCellArray.indexOf('No_Print_On_Remit') + 1,
                printIndex: rawCellArray.indexOf('Print_Only') + 1,
                adminIndex: rawCellArray.indexOf('Admin_Override') + 1,
                pendIndex: rawCellArray.indexOf('Override_Pend') + 1,
                deniedIndex: rawCellArray.indexOf('Override_Denied') + 1,
                supressIndex: rawCellArray.indexOf('Suppress_EOB_Remit') + 1,
                patientIndex: rawCellArray.indexOf('Patient_Responsibility') + 1,
                hipaaGroupIndex: rawCellArray.indexOf('HIPAA_Group_Code') + 1,
                hipaaIndex: rawCellArray.indexOf('HIPAA_Code') + 1,
                hipaaRemitIndex: rawCellArray.indexOf('HIPAA_Remit_Code') + 1,
                longDescriptionIndex: rawCellArray.indexOf('Long_Description') + 1,
            }

            if(exCodeIndexCollection.exCodeIndex > 0 && exCodeIndexCollection.resultIndex > 0) {

                for (let i = 1; i < rowRange; i++) {
                    //for each new array we skip over the previous records determined by the column length, removing 1 to account for our zero based index at the beginning
                    let rowMultiplier = columnRange * i - 1;

                    //start with ex code
                    if (exCodeIndexCollection.exCodeIndex > 0) {
                        currentExCode.ex_Code = rawCellArray[(rowMultiplier + exCodeIndexCollection.exCodeIndex)].toString();
                    }

                    //ex result
                    if (exCodeIndexCollection.resultIndex > 0) {
                        currentExCode.ex_Result = rawCellArray[(rowMultiplier + exCodeIndexCollection.resultIndex)].toString().toUpperCase();
                    }

                    //description
                    if (exCodeIndexCollection.descriptionIndex > 0) {
                        currentExCode.ex_Description = rawCellArray[(rowMultiplier + exCodeIndexCollection.descriptionIndex)].toString();
                    }

                    //category
                    if (exCodeIndexCollection.categoryIndex > 0) {
                        currentExCode.category = rawCellArray[(rowMultiplier + exCodeIndexCollection.categoryIndex)].toString().toUpperCase();
                    }

                    //no print on remit
                    if (exCodeIndexCollection.noPrintIndex > 0) {
                        if (rawCellArray[(rowMultiplier + exCodeIndexCollection.noPrintIndex)].toString() === "Y" ||
                            rawCellArray[(rowMultiplier + exCodeIndexCollection.noPrintIndex)].toString() === "1") {
                            currentExCode.no_Print_On_Remit = "1";
                        }
                        else {
                            currentExCode.no_Print_On_Remit = "0";
                        }

                    }

                    //print only
                    if (exCodeIndexCollection.printIndex > 0) {
                        if (rawCellArray[(rowMultiplier + exCodeIndexCollection.printIndex)].toString() === "Y" ||
                            rawCellArray[(rowMultiplier + exCodeIndexCollection.printIndex)].toString() === "1") {
                            currentExCode.print_Only = true;
                        }
                        else {
                            currentExCode.print_Only = false;
                        }
                    }

                    //admin override
                    if (exCodeIndexCollection.adminIndex > 0) {
                        if (rawCellArray[(rowMultiplier + exCodeIndexCollection.adminIndex)].toString() === "Y" ||
                            rawCellArray[(rowMultiplier + exCodeIndexCollection.adminIndex)].toString() === "1") {
                            currentExCode.admin_Override = "1";
                        }
                        else {
                            currentExCode.admin_Override = "0";
                        }
                    }

                    if (exCodeIndexCollection.pendIndex > 0) {
                        if (rawCellArray[(rowMultiplier + exCodeIndexCollection.pendIndex)].toString() === "Y" ||
                            rawCellArray[(rowMultiplier + exCodeIndexCollection.pendIndex)].toString() === "1") {
                            currentExCode.override_Pend = true;
                        }
                        else {
                            currentExCode.override_Pend = false;
                        }
                    }

                    if (exCodeIndexCollection.deniedIndex > 0) {
                        if (rawCellArray[(rowMultiplier + exCodeIndexCollection.deniedIndex)].toString() === "Y" ||
                            rawCellArray[(rowMultiplier + exCodeIndexCollection.deniedIndex)].toString() === "1") {
                            currentExCode.override_Denied = true;
                        }
                        else {
                            currentExCode.override_Denied = false;
                        }
                    }

                    if (exCodeIndexCollection.supressIndex > 0) {
                        if (rawCellArray[(rowMultiplier + exCodeIndexCollection.supressIndex)].toString() === "Y" ||
                            rawCellArray[(rowMultiplier + exCodeIndexCollection.supressIndex)].toString() === "1") {
                            currentExCode.suppress_EOB_Remit = true;
                        }
                        else {
                            currentExCode.suppress_EOB_Remit = false;
                        }
                    }

                    if (exCodeIndexCollection.patientIndex > 0) {
                        if (rawCellArray[(rowMultiplier + exCodeIndexCollection.patientIndex)].toString() === "Y" ||
                            rawCellArray[(rowMultiplier + exCodeIndexCollection.patientIndex)].toString() === "1") {
                            currentExCode.patient_Responsibility = true;
                        }
                        else {
                            currentExCode.patient_Responsibility = false;
                        }
                    }

                    //hipaa group
                    if (exCodeIndexCollection.hipaaGroupIndex > 0) {
                        currentExCode.hipaA_Group_Code = rawCellArray[(rowMultiplier + exCodeIndexCollection.hipaaGroupIndex)].toString().toUpperCase();
                    }

                    //hipaa code
                    if (exCodeIndexCollection.hipaaRemitIndex > 0) {
                        currentExCode.hipaA_Remit_Code = rawCellArray[(rowMultiplier + exCodeIndexCollection.hipaaRemitIndex)].toString().toUpperCase();
                    }

                    //hipaa code
                    if (exCodeIndexCollection.longDescriptionIndex > 0) {
                        currentExCode.long_Description = rawCellArray[(rowMultiplier + exCodeIndexCollection.longDescriptionIndex)].toString().toUpperCase();
                    }

                    currentExCode.vbasoftware_database = currentDB;

                    currentExCode.vbapi_Token = getWithExpiry('vbapi_Token');

                    if((currentExCode.ex_Code.length > 0)){
                        exCodeArray.push({...currentExCode});
                    }
                    else {
                        // setValidationText("Group ID, Plan ID, and Vendor are required.");
                        // setValidationError(true);
                    }

                    currentExCode.ex_Code = initialExCodeState.ex_Code;
                    currentExCode.ex_Description = initialExCodeState.ex_Description;
                    currentExCode.ex_Result = initialExCodeState.ex_Result;
                    currentExCode.category = initialExCodeState.category;
                    currentExCode.no_Print_On_Remit = initialExCodeState.no_Print_On_Remit;
                    currentExCode.print_Only = initialExCodeState.print_Only;
                    currentExCode.admin_Override = initialExCodeState.admin_Override;
                    currentExCode.override_Pend = initialExCodeState.override_Pend;
                    currentExCode.override_Denied = initialExCodeState.override_Denied;
                    currentExCode.suppress_EOB_Remit = initialExCodeState.suppress_EOB_Remit;
                    currentExCode.patient_Responsibility = initialExCodeState.patient_Responsibility;
                    currentExCode.hipaA_Code = initialExCodeState.hipaA_Code;
                    currentExCode.hipaA_Remit_Code = initialExCodeState.hipaA_Remit_Code;
                    currentExCode.long_Description = initialExCodeState.long_Description;
                    currentExCode.hipaA_Group_Code = initialExCodeState.hipaA_Group_Code;

                    clearExCodes();
                }


                importExCodes(exCodeArray);

                excelData.Sheets.ExCodes = undefined;
            }
            else {
                //setValidationError(true);
            }

        }
    }
    catch(e) {
        console.log("ERROR", e);

        setErrorAlert(true);
        //clear it out after errors in case of rerendering otherwise the error spams will continue until morale improves
        excelData.Sheets.ExCodes = undefined;
    }

    return (
        <div>
            {successAlert ? <Alert className="groupAlertStyles" severity='success' onClose={() => setSuccessAlert(false)} variant="filled">
                <AlertTitle>Success!</AlertTitle>
                Ex Code Import Complete!
            </Alert> : <></> }
            {errorAlert ? <Alert className="groupAlertStyles" severity='error' onClose={() => setErrorAlert(false)} variant="filled">
                <AlertTitle>Error!</AlertTitle>
                There was an error with this file!
            </Alert> : <></> }
            <Dialog
                open={validationError}
                onClose={handleValidationClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    {"Validation Error"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {validationText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleValidationClose}>OK</Button>
                </DialogActions>
            </Dialog>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
}

export default React.memo(BulkExCodePut)

BulkExCodePut.propTypes = {
    excelData: PropTypes.object.isRequired
};
